(() => {
 if(window.vitalaReasonsInstalled)return;window.vitalaReasonsInstalled=true;
 function init(root){
  if(root.dataset.ready)return;root.dataset.ready="true";
  const track=root.querySelector(".vcs-track"),cards=[...root.querySelectorAll(".vcs-reason")],dots=[...root.querySelectorAll("[data-card]")],arrows=[...root.querySelectorAll("[data-dir]")];
  if(!track||!cards.length)return;
  let current=0,queued=false;
  const left=card=>card.offsetLeft-cards[0].offsetLeft;
  function sync(){queued=false;let best=Infinity;cards.forEach((card,i)=>{const distance=Math.abs(left(card)-track.scrollLeft);if(distance<best){best=distance;current=i;}});dots.forEach((d,i)=>d.setAttribute("aria-current",i===current?"true":"false"));arrows.forEach(a=>a.disabled=Number(a.dataset.dir)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);}
  function go(i){track.scrollTo({left:left(cards[Math.max(0,Math.min(i,cards.length-1))]),behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth"});}
  dots.forEach(d=>d.addEventListener("click",()=>go(Number(d.dataset.card))));
  arrows.forEach(a=>a.addEventListener("click",()=>go(current+Number(a.dataset.dir))));
  track.addEventListener("scroll",()=>{if(!queued){queued=true;requestAnimationFrame(sync);}},{passive:true});
  if(window.ResizeObserver)new ResizeObserver(sync).observe(track);
  sync();
 }
 function discover(){document.querySelectorAll(".vcs-reasons").forEach(init);}
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",discover,{once:true});else discover();
 document.addEventListener("shopify:section:load",discover);
})();

